






import { Component, Vue, Provide,Prop } from "vue-property-decorator";
// import { arrayOrNull } from "@/utils";
// import { UserWorkStatus } from "@/pbjs/xcommon/enum_pb";

const Case = () => import("./case.vue");


@Component({
  name: "Completed",
  components: { Case }
})
export default class Completed extends Vue {
  @Prop() private tabname2:any
  @Provide() private activeName: string = "second";
//   @Provide() private tab: any = localStorage.getItem("tabAuditOrder");
  @Provide() private issearchUserDone: boolean = false;
  @Provide() private workStatus: any = "";
  @Provide() private ordertakeStatus: number = 0;
  @Provide() private country: any='';
//   private handleClick(tab: any, event: any) {
//     // 点击tab,缓存
//     localStorage.setItem("tabAuditOrder", tab.name);
//   }
  private created() {
    
  }
//   private destroyed() {
//     // 页面销毁时,将缓存修改为默认值，以便第一次进入时查看默认选中tab
//     localStorage.setItem("tabAuditOrder", "first");
//   }
}
  
